import styled from 'styled-components';

export const FooterWrapper = styled.div`
.footer-section1{
    background-color: #e7faca;
    background-image: none;
    min-height: 30px;
    border-style: solid;
    border-width: 0;
    border-top-width: 5px;
    border-top-color: #647f19;
    padding-top: 45px;
    padding-bottom: 45px;
}
.footer-section2{
    background-color: black;
    background-image: none;
    min-height: 30px;
    border-style: solid;
    border-width: 0;
    border-top-width: 1px;
    border-top-color: #647f19;
    padding-top: 20px;
    padding-bottom: 20px;
}
a{
    text-decoration: none;
    color: #647f19;
}
li{
    margin-right: 1vw;
}
ul{
    list-style: none;
    display: flex;
}
span{
    font-size:larger;
}
`;
